import { render } from "./Team.vue?vue&type=template&id=670b02c2&scoped=true"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"

import "./Team.vue?vue&type=style&index=0&id=670b02c2&lang=scss&scoped=true"
import "./Team.vue?vue&type=style&index=1&id=670b02c2&lang=css"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670b02c2"]])

export default __exports__